export default ctx => action =>
  new Promise(async resolve => {
    ctx.$gtag.event(action.options.eventName)
    resolve()
  })
